import Service from './service';

export default class DirectionService extends Service {
  baseApi = '/directions';

  async getDirections(query) {
    return await this.getResource(this.baseApi, query);
  }

  async createDirection(body) {
    return await this.postResource(this.baseApi, body, { returnErrors: true });
  }

  async updateDirection(id, body) {
    return await this.putResource(`${this.baseApi}/${id}`, body, { returnErrors: true });
  }

  async deleteDirection(id) {
    return await this.deleteResource(`${this.baseApi}/${id}`);
  }
}
